import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';

export type AppLanguage = 'en';

@Injectable({ providedIn: 'root' })
export class LocalizationService {
  private readonly defaultLanguage: AppLanguage = 'en';
  private readonly translateService = inject(TranslateService);
  private readonly languageStream$ = new BehaviorSubject<AppLanguage>(this.defaultLanguage);

  public readonly currentLanguage$ = this.languageStream$.asObservable();

  public init(): void {
    this.setLanguage('en');
  }

  public setLanguage(language: AppLanguage): void {
    this.translateService.use(language);
    this.languageStream$.next(language);
  }
}
